<template>
    <div v-resize="onResize">
        <div ref="resizableDiv">
            <slot name="table" :table-height="tableHeight" />
        </div>
        <slot name="filter" />
    </div>
</template>

<script>
export default {
    name: "resizable-page",

    props: {
        footerHeight: {
            type: Number,
            default: 59, //default v-data-table footer height
        },
    },

    data() {
        return {
            tableHeight: 0,
        };
    },

    methods: {
        onResize() {
            this.tableHeight =
                window.innerHeight -
                this.$refs.resizableDiv.getBoundingClientRect().y -
                this.footerHeight;
        },
    },
};
</script>
